import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";
import { Label } from "../ui/label";
import { cn } from "@/lib/utils";

const SimpleSelect = ({
  value,
  label,
  onChange,
  options,
  placeholder = "Select...",
  className = "",
}: {
  value: string;
  label?: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col gap-2 w-full", className)}>
      {label && <Label>{label}</Label>}
      <Select value={`${value}`} onValueChange={onChange}>
        <SelectTrigger className="h-10 w-full">
          <SelectValue
            placeholder={value && value !== "" ? value : placeholder}
          />
        </SelectTrigger>
        <SelectContent side="top">
          {options.map(({ value, label }) => (
            <SelectItem key={value} value={`${value}`}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SimpleSelect;
